import gql from 'graphql-tag'

export const CREATE_EVENT = gql`
  mutation createEvent($event: CreateEventData!, $organizationSlug: String!) {
    createEvent(event: $event, organizationSlug: $organizationSlug) {
      id
      title
    }
  }
`

export const UPDATE_EVENT = gql`
  mutation updateEvent(
    $id: ID!
    $event: UpdateEventData!
    $location: LocationInput!
    $publishChanges: Boolean
  ) {
    updateEvent(eventId: $id, event: $event, location: $location, publishChanges: $publishChanges) {
      id
      slug
    }
  }
`

export const CONFIGURE_SKIDATA_EVENT = gql`
  mutation configureSkidataEvent($eventId: ID!, $config: SkidataEventConfigInput!) {
    configureSkidataEvent(eventId: $eventId, config: $config) {
      id
      metadata
    }
  }
`

export const GET_EVENTS = gql`
  query getEvents($organizationSlug: String!) {
    getEvents(organizationSlug: $organizationSlug) {
      id
      title
      to
      from
      eventTemplateId
      eventTemplate {
        id
        title
      }
      orderItems {
        id
        name
        eventId
        itemMeta
      }
    }
  }
`

export const UPDATE_EVENT_WITH_EVENT_TEMPLATE_ID = gql`
  mutation UpdateEventWIthEventTemplateId(
    $organizationSlug: String!
    $eventTemplateId: ID!
    $eventInput: [PerformanceInput!]!
    $publishChanges: Boolean
    $VATPercentage: Float
  ) {
    updateEventWithEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
      eventInput: $eventInput
      publishChanges: $publishChanges
      VATPercentage: $VATPercentage
    ) {
      id
    }
  }
`
export const CHANGE_EVENT_VENUE = gql`
  mutation changeEventVenue($eventId: ID!, $venueId: ID!) {
    changeEventVenue(eventId: $eventId, venueId: $venueId)
  }
`

export const PUBLISH_EVENT = gql`
  mutation publishEvent($id: ID, $eventTemplateId: ID) {
    publishEvent(eventId: $id, eventTemplateId: $eventTemplateId)
  }
`

export const EVENT_SOLD_OUT = gql`
  mutation eventSoldOut($id: ID!, $organizationSlug: String!) {
    eventSoldOut(eventId: $id, organizationSlug: $organizationSlug) {
      id
      soldOut
    }
  }
`

export const EVENT_AVAILABLE = gql`
  mutation eventAvailable($id: ID!, $organizationSlug: String!) {
    eventAvailable(eventId: $id, organizationSlug: $organizationSlug) {
      id
    }
  }
`

export const EVENT_CANCELED = gql`
  mutation eventCanceled($id: ID!, $organizationSlug: String!) {
    eventCanceled(eventId: $id, organizationSlug: $organizationSlug) {
      id
    }
  }
`

export const UPDATE_CANCELLATION_NOTIFICATION = gql`
  mutation updateCancellationNotification(
    $id: ID!
    $organizationSlug: String!
    $notification: String!
  ) {
    updateCancellationNotification(
      eventId: $id
      organizationSlug: $organizationSlug
      cancellationNotification: $notification
    )
  }
`

export const GET_EVENTS_AND_QUOTA = gql`
  query getEventsAndQuota($organizationSlug: String!, $filter: String) {
    getEvents(organizationSlug: $organizationSlug, filter: $filter) {
      id
      title
      to
      from
      cover
      extraModules {
        ticketing
      }
      eventTemplate {
        id
        title
        durationInMins
      }
      totalNumberOfTickets
      totalEarnings
      totalTicketsSold
      location {
        city
      }
    }
    getOrganization(organizationSlug: $organizationSlug) {
      type
    }
    me {
      eventQuota
    }
  }
`

export const GET_ORGANIZATION_EVENTS_PAGE = gql`
  query GetOrganizationEventsPage(
    $organizationSlug: String!
    $filter: String
    $page: Int!
    $perPage: Int!
    $searchTerm: String
  ) {
    getOrganizationEventsPage(
      organizationSlug: $organizationSlug
      filter: $filter
      page: $page
      perPage: $perPage
      searchTerm: $searchTerm
    ) {
      items {
        id
        title
        to
        from
        cover
        extraModules {
          ticketing
        }
        eventTemplate {
          id
          title
          durationInMins
        }
        location {
          city
        }
      }
      hasMore
      organizationType
      eventQuota
    }
  }
`

export const GET_ORGANIZATION_EVENT_SALES_STATS = gql`
  query GetOrganizationEventSalesStats(
    $organizationSlug: String!
    $filter: String
    $page: Int!
    $perPage: Int!
    $searchTerm: String
  ) {
    getOrganizationEventsPage(
      organizationSlug: $organizationSlug
      filter: $filter
      page: $page
      perPage: $perPage
      searchTerm: $searchTerm
    ) {
      items {
        id
        totalNumberOfTickets
        totalEarnings
        totalTicketsSold
      }
    }
  }
`

export const GET_EVENTS_REPORTS = gql`
  query getEventsReport(
    $organizationSlug: String!
    $searchTerm: String
    $from: String
    $to: String
  ) {
    getEventsReport(
      organizationSlug: $organizationSlug
      searchTerm: $searchTerm
      from: $from
      to: $to
    )
  }
`

export const GET_THEATER_SUMMARY_REPORTS = gql`
  query getTheaterSummaryReports(
    $organizationSlug: String!
    $searchTerm: String
    $from: String
    $to: String
  ) {
    getEventsReport(
      organizationSlug: $organizationSlug
      searchTerm: $searchTerm
      from: $from
      to: $to
      summaryOnly: true
    )
  }
`

export const GET_WORKING_EVENTS = gql`
  query getWorkingEvents {
    getWorkingEvents {
      id
      title
      to
      from
      cover
      extraModules {
        ticketing
      }
      organization {
        slug
        type
      }
      totalNumberOfTickets
      totalEarnings
      totalTicketsSold
      location {
        city
      }
    }
  }
`

export const GET_ORGANIZATION_WORKING_EVENTS = gql`
  query getOrganizationWorkingEvents($organizationSlug: String!) {
    getOrganizationWorkingEvents(organizationSlug: $organizationSlug) {
      id
      title
      to
      from
      cover
      extraModules {
        ticketing
      }
      organization {
        slug
        type
      }
      totalNumberOfTickets
      totalEarnings
      totalTicketsSold
      location {
        city
      }
    }
  }
`

export const SEARCH_EVENTS_SUPERADMIN = gql`
  query SearchEventsSuperadmin($q: String!, $limit: Int) {
    searchEventsSuperadmin(q: $q, limit: $limit) {
      id
      title
      from
      to
      status
      metadata
      deletedAt
    }
  }
`

export const GET_ALL_PERFORMANCES_BT_EVENT_TEMPLATE_ID = gql`
  query getAllPerformancesByEventTemplateId($eventTemplateId: ID!) {
    getAllPerformancesByEventTemplateId(eventTemplateId: $eventTemplateId) {
      id
      title
      createdAt
      to
      from
    }
  }
`

export const GET_EVENT_FLOOR_PLAN = gql`
  query getEventFloorPlan($eventId: ID!) {
    getEventFloorPlan(eventId: $eventId) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      venueId
      hasTheaterSubscriptionSales
      venueAvailability {
        eventId
        availability
      }
      orderItems {
        id
        name
        type
        price
        currency
        createdAt
        updatedAt
        deletedAt
        quantity
        initialQuantity
        from
        to
        itemMeta
        sectionSeats
        color
      }
    }
    getVenues {
      id
      imageUrl
      seats
      predefinedSections
      name
    }
  }
`
export const GET_EVENT_FLOOR_PLAN_AND_ORDER_ITEMS = gql`
  query getEventFloorPlanAndOrderItems(
    $eventId: ID!
    $includeOrderItemsWithTicketSellerTrue: Boolean
  ) {
    getEventFloorPlanAndOrderItems(
      eventId: $eventId
      includeOrderItemsWithTicketSellerTrue: $includeOrderItemsWithTicketSellerTrue
    ) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      venueId
      canceled
      venue {
        name
        seats
        predefinedSections
        wheelchairSeats
        imageUrl
      }
      venueAvailability {
        eventId
        availability
      }
      orderItems {
        id
        name
        type
        price
        currency
        createdAt
        membership
        prepaidCoupon
        updatedAt
        description
        deletedAt
        quantity
        initialQuantity
        orderItemTemplateId
        from
        to
        sectionSeats
        itemMeta
        color
        bundleOffer {
          id
          availableQuantity
          quantityInterval
          freeQuantity
        }
      }
      metadata
    }
  }
`

export const GET_EVENT_PARTER_AS_TICKET_ORDER_ITEMS = gql`
  query getEventParterAsTicketOrderItems(
    $eventId: ID!
    $includeOrderItemsWithTicketSellerTrue: Boolean
    $accessCode: String
  ) {
    getEventParterAsTicketOrderItems(
      eventId: $eventId
      includeOrderItemsWithTicketSellerTrue: $includeOrderItemsWithTicketSellerTrue
      accessCode: $accessCode
    ) {
      id
      name
      type
      price
      currency
      createdAt
      membership
      prepaidCoupon
      updatedAt
      description
      deletedAt
      quantity
      initialQuantity
      orderItemTemplateId
      from
      to
      sectionSeats
      itemMeta
      color
      bundleOffer {
        id
        availableQuantity
        quantityInterval
        freeQuantity
      }
    }
  }
`

export const GET_EVENT_SETTINGS = gql`
  query getEventSettings($id: ID!) {
    getEvent: getEventSettings(id: $id) {
      id
      title
      attendeeLimit
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      organizerMessage
      highlightedData
      faqs
      createdAt
      status
      organization {
        id
        slug
        metaPixelId
      }
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
      }
      location {
        address1
        city
        longitude
        latitude
        address2
        state
        postalCode
        country
        venue
      }
      metadata
      eventCategory {
        id
        name
        subCategoryLabel
      }
      interests {
        id
        name
      }
    }
  }
`

export const GET_EVENT_PREVIEW_DATA = gql`
  query getEventPreviewData($eventId: ID!) {
    getEventPreviewData(eventId: $eventId) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      organizerMessage
      highlightedData
      faqs
      status
      location {
        address1
        city
        longitude
        latitude
        address2
        state
        postalCode
        country
        venue
      }
      metadata
      eventCategory {
        id
        name
        subCategoryLabel
      }
      organization {
        publicName
        logo
        description
        webLink
        email
        facebookLink
        instagramLink
      }
      orderItems {
        id
        price
      }
    }
  }
`

export const GET_EVENT_SETTINGS_AND_LOGGED_USER = gql`
  query getEventSettings($id: ID!) {
    getEvent: getEventSettings(id: $id) {
      id
      title
      to
      from
      numberOfZones
      attendeeFields
      cover
      description
      slug
      organizerMessage
      highlightedData
      faqs
      createdAt
      status
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
      }
      location {
        address1
        city
        longitude
        latitude
        address2
        state
        postalCode
        country
        venue
      }
      metadata
      eventCategory {
        id
        name
        subCategoryLabel
      }
      interests {
        id
        name
      }
    }
    me {
      flags
    }
  }
`

export const GET_EVENT_ADS = gql`
  query getEventAds($eventId: ID!) {
    getEventAds(eventId: $eventId) {
      url
      title
      imageUrl
      logoUrl
    }
  }
`
export const GET_EVENT_NUM_OF_REMAINING_TICKETS = gql`
  query getEventNumOfRemainingTickets($eventId: ID!) {
    getEventNumOfRemainingTickets(eventId: $eventId)
  }
`

export const GET_EVENT_AND_LOGGED_USER = gql`
  query getEventAndUser($id: ID!) {
    getEvent(id: $id) {
      id
      title
      eventCode
      from
      to
      venueId
      soldOut
      applicationsOpen
      canceled
      cancellationNotification
      status
      hasPurchasableTickets
      cover
      scheduledPublishDate
      eventCategory {
        name
      }
      extraModules {
        id
        workshops
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        scanEntries
        ticketing
        floorPlan
        ticketPersonalization
      }
      location {
        venue
      }
      slug
    }
    me {
      id
      firstName
      lastName
      type
      flags
      isVerifiedByCoreEvent
    }
    getPendingRequestsCount(eventId: $id)
    getEventOrganizationType(eventId: $id)
  }
`

export const GET_EVENT_CATEGORIES = gql`
  query getEventCategories($id: ID!) {
    getEventCategories(id: $id) {
      id
      slug
      attendeeFields
      flags
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
      }
      categories {
        id
        name
        color
        zones
        default
      }
      id
      numberOfZones
      title
      currency
      to
      from
      flags
      builder {
        id
      }
      applicationsOpen
    }
  }
`

export const GET_EVENT_USERS_AND_INVITES = gql`
  query getEventUsersAndInvites($organizationSlug: String!, $eventId: Int!) {
    getEventUsers(organizationSlug: $organizationSlug, eventId: $eventId) {
      id
      firstName
      lastName
      email
      organizationRole
    }
    getEventInvites(organizationSlug: $organizationSlug, eventId: $eventId) {
      id
      email
      organizationRole
      expired
    }
  }
`

export const GET_EVENT_AND_ORDER_ITEMS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsAndOrderItemsByEventTemplateId($organizationSlug: String!, $eventTemplateId: ID!) {
    getEventsAndOrderItemsByEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      title
      from
      promoCodes {
        id
        name
        code
        createdAt
        updatedAt
        from
        to
      }
      orderItems {
        id
        eventId
        name
        type
        price
        currency
        description
        membership
        createdAt
        updatedAt
        quantity
        initialQuantity
        itemMeta
        from
        to
        subscriptionId
        ticketSellerOrganizations {
          id
          name
        }
      }
    }
  }
`

export const GET_EVENTS_ORDERS_AND_ORDER_ITEMS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsOrdersAndOrderItemsByEventTemplateId(
    $eventTemplateId: ID!
    $pagination: Pagination!
    $searchTerm: String
    $eventId: ID
  ) {
    getEventsOrdersAndOrderItemsByEventTemplateId(
      eventTemplateId: $eventTemplateId
      pagination: $pagination
      searchTerm: $searchTerm
      eventId: $eventId
    )
  }
`

export const GET_EVENTS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsByEventTemplateId($organizationSlug: String!, $eventTemplateId: ID!) {
    getEventsByEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      performanceType
      title
      from
      to
      eventCode
      slug
      venueId
      audienceCapacity
      applicationsOpen
      location {
        id
        venue
      }
      orderItems {
        orderItemTemplateId
        id
        name
        quantity
        initialQuantity
      }
    }
  }
`

export const GET_EVENTS_WITH_TICKET_SELLER_ORGANIZATIONS_BY_EVENT_TEMPLATE_ID = gql`
  query GetEventsWithTicketSellerOrganizationsByEventTemplateId(
    $organizationSlug: String!
    $eventTemplateId: ID!
  ) {
    getEventsWithTicketSellerOrganizationsByEventTemplateId(
      organizationSlug: $organizationSlug
      eventTemplateId: $eventTemplateId
    ) {
      id
      performanceType
      title
      from
      to
      eventCode
      totalTicketsSold
      createdAt
      totalAdditionalCapacityTicketsSold
      additionalCapacity
      slug
      venueId
      audienceCapacity
      metadata
      applicationsOpen
      soldOut
      canceled
      status
      location {
        id
        venue
      }
      isIncludedInSubscription
      hasTheaterSubscriptionSales
      orderItems {
        orderItemTemplateId
        id
        name
        quantity
        initialQuantity
        ticketSellerOrganizations {
          id
          name
        }
      }
    }
  }
`

export const GET_PRINT_DATA = gql`
  query GetPrintData($id: ID!, $attendeeUUID: String!) {
    getEvent: getEventPrintData(id: $id) {
      title
      numberOfZones
      builder {
        id
        items
        backgroundImage
        backItems
        backBackgroundImage
        hasBackSide
        orientation
        format
      }
      attendeeFields
    }
    getAttendee(attendeeUUID: $attendeeUUID) {
      id
      category {
        name
        color
        zones
      }
      fields
      avatar
      zones
      barcode
      qrcode
      printCount
    }
  }
`

export const GET_BULK_PRINT_DATA = gql`
  query GetBulkPrintData($eventId: ID!, $attendeeIds: [ID]) {
    getEvent: getEventPrintData(id: $eventId) {
      title
      numberOfZones
      builder {
        items
        backgroundImage
        backItems
        backBackgroundImage
        hasBackSide
        orientation
        format
      }
      attendeeFields
    }
    getAccreditations(attendeeIds: $attendeeIds, eventId: $eventId) {
      id
      barcode
      qrcode
      category {
        name
        color
        zones
      }
      fields
      avatar
      zones
      printCount
    }
  }
`

export const SEARCH_EVENT_ACCREDITATIONS = gql`
  query searchEventAccreditations($eventId: ID!, $status: String!, $input: String!) {
    searchEventAccreditations(eventId: $eventId, status: $status, input: $input)
  }
`

export const GET_EVENT_ACCREDITATIONS_ONLY = gql`
  query getEventAccreditationsOnly(
    $status: String
    $filters: JSON
    $eventId: ID!
    $quickSearch: String
    $visibleFields: [String!]
    $pagination: Pagination
  ) {
    getEventAccreditations(
      eventId: $eventId
      status: $status
      quickSearch: $quickSearch
      visibleFields: $visibleFields
      filters: $filters
      pagination: $pagination
    )
  }
`

export const GET_EMAIL_RECIPIENT_PICKER_ACCREDITATIONS = gql`
  query GetEmailRecipientPickerAccreditations($eventId: ID!) {
    getEmailRecipientPickerAccreditations(eventId: $eventId)
  }
`

export const CHECK_IF_ATTENDEE_ALREADY_EXISTS = gql`
  query checkIfAttendeeAlreadyExistsOnEvent($eventId: ID!, $attendee: AttendeePersonalInput!) {
    checkIfAttendeeAlreadyExistsOnEvent(eventId: $eventId, attendee: $attendee)
  }
`

export const GET_EVENT_DETAILS = gql`
  query getEventAccreditations($eventId: ID!) {
    getEvent: getEventAccreditationDetails(id: $eventId) {
      id
      managed
      attendeeFields
      currency
      slug
      quickPrint
      venueId
      audienceCapacity
      builder {
        id
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
        floorPlan
      }
      eventUtils {
        id
        inviteFormStyles
      }
      categories {
        id
        color
        name
        zones
      }
      organization {
        type
      }
    }
    getAccreditationCount(eventId: $eventId)
  }
`

export const GET_EVENT_DETAILS_WITH_FILTERED_ATTENDEE_FIELDS = gql`
  query getEventAccreditationListMetadata($eventId: ID!) {
    getEventWithFilteredAttendeeFields(id: $eventId) {
      id
      managed
      attendeeFields
      quickPrint
      attendeeLimit
      registeredAttendeesCount
      builder {
        id
      }
      extraModules {
        categoriesAndZones
        mobileApp
        workshops
        floorPlan
        ticketing
      }
      categories {
        id
        color
        name
        zones
      }
    }
  }
`

export const GET_EVENT_DETAILS_WITH_ORDER_ITEMS = gql`
  query getEventAccreditations($eventId: ID!) {
    getEvent: getEventAccreditationDetails(id: $eventId) {
      id
      managed
      attendeeFields
      currency
      from
      to
      slug
      quickPrint
      venueId
      audienceCapacity
      builder {
        id
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
        floorPlan
      }
      eventUtils {
        id
        inviteFormStyles
      }
      categories {
        id
        color
        name
        zones
      }
    }
    getAccreditationCount(eventId: $eventId)
    getOrderItems(eventId: $eventId) {
      items {
        id
        initialQuantity
      }
      totalCount
      hasParterTickets
    }
  }
`

export const GET_EVENT_BUILDER = gql`
  query getEventBuilder($id: ID!) {
    getEvent(id: $id) {
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        workshops
      }
      attendeeFields
      title
      numberOfZones
      builder {
        items
        backgroundImage
        backItems
        backBackgroundImage
        hasBackSide
        orientation
        format
      }
    }
  }
`

export const GET_EVENTS_SUPERADMIN = gql`
  query GetEventsSuperadmin {
    getEvents {
      id
      title
      accreditationsCount
      deletedAt
      users {
        id
        email
      }
    }
  }
`
export const GET_ORGANIZATION_ORDER_ITEMS = gql`
  query GetOrganizationOrderItems($organizationSlug: String!) {
    getOrganizationOrderItems(organizationSlug: $organizationSlug) {
      id
      name
      type
      price
      itemMeta
      currency
      description
      createdAt
      updatedAt
      quantity
      initialQuantity
      from
      to
      organizationId
      prepaidCouponId
      prepaidCouponInfo {
        description
      }
    }
  }
`

export const SOFT_DELETE_EVENT = gql`
  mutation SoftDeleteEvent($eventId: ID!) {
    deleteEvent(eventId: $eventId)
  }
`

export const DUPLICATE_EVENT = gql`
  mutation DuplicateEvent($eventId: ID!) {
    duplicateEvent(eventId: $eventId) {
      id
      title
    }
  }
`

export const GET_EVENT_BY_SLUG = gql`
  query GetEventBySlug($slug: String!, $ref: String) {
    getEventBySlug(slug: $slug, ref: $ref) {
      id
      attendeeFields
      numberOfZones
      title
      soldOut
      to
      performanceType
      from
      slug
      cover
      fixedFeePerTicket
      variableFeePercentage
      description
      managed
      applicationsOpen
      audienceCapacity
      venueId
      eventTemplateId
      flags
      numOfRemainingTickets
      canceled
      cancellationNotification
      eventTemplate {
        title
        description
        durationInMins
        break
        cover
      }
      interests {
        id
        name
      }
      translation {
        translationsJSON
      }
      eventUtils {
        id
        inviteFormStyles
      }
      coverImagePrimaryColor {
        r
        g
        b
      }
      workshops {
        id
        name
        to
        from
        lecturers {
          id
          fields
        }
        attendanceLimit
        attending
        unlimitedAttendance
        description
      }
      extraModules {
        workshops
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
        floorPlan
        ticketPersonalization
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
      eventCategory {
        id
        name
      }
      organization {
        fixedFeePerTicket
        variableFeePercentage
        id
        publicName
        metaPixelId
        logo
        preferredLanguage
        description
        facebookLink
        webLink
        email
        type
      }
    }
  }
`
export const GET_APPLICATION_HEADER_DATA = gql`
  query GetApplicationHeaderData($slug: String!) {
    getApplicationHeaderData(slug: $slug) {
      id
      eventUtils {
        id
        inviteFormStyles
      }
    }
  }
`
export const GET_WORKSHOP_DETAILS_BY_EVENT_SLUG = gql`
  query GetWorkshopDetailsByEventSlug($slug: String!) {
    getWorkshopDetailsByEventSlug(slug: $slug) {
      id
      attendeeFields
      numberOfZones
      title
      soldOut
      to
      performanceType
      from
      slug
      cover
      fixedFeePerTicket
      variableFeePercentage
      description
      managed
      applicationsOpen
      audienceCapacity
      venueId
      eventTemplateId
      flags
      canceled
      cancellationNotification
      interests {
        id
        name
      }
      workshops {
        id
        name
        to
        from
        lecturers {
          id
          fields
        }
        attendanceLimit
        attending
        unlimitedAttendance
        description
      }
      eventCategory {
        id
        name
      }
    }
  }
`
export const GET_EVENT_DETAILS_FOR_REGISTER_CONTAINER = gql`
  query getEventDetailsForRegisterContainer($slug: String!) {
    getEventDetailsForRegisterContainer(slug: $slug) {
      id
      numberOfZones
      title
      to
      performanceType
      from
      slug
      cover
      description
      managed
      audienceCapacity
      venueId
      eventTemplateId
      coverImagePrimaryColor {
        r
        g
        b
      }
      extraModules {
        workshops
        mobileApp
        ticketing
        floorPlan
        ticketPersonalization
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
    }
  }
`

export const GET_EVENT_DYNAMIC_DATA = gql`
  query getEventBasicData($slug: String!) {
    getEventBasicData(slug: $slug) {
      id
      slug
      soldOut
      applicationsOpen
      canceled
      cancellationNotification
      to
      from
      organizationId
      fixedFeePerTicket
      variableFeePercentage
      attendeeFields
      flags
      eventPasswords {
        startsAt
        expiresAt
      }
    }
  }
`

export const GET_EVENT_ATTENDEE_CAPACITY = gql`
  query getEventAttendeeCapacity($slug: String!) {
    getEventAttendeeCapacity(slug: $slug) {
      id
      attendeeLimit
      registeredAttendeesCount
    }
  }
`

export const GET_EVENT_ADDITIONAL_DATA_FOR_REGISTER_CONTAINER = gql`
  query getEventAdditionalDataForRegisterContainer($slug: String!) {
    getEventAdditionalDataForRegisterContainer(slug: $slug) {
      slug
      organization {
        fixedFeePerTicket
        variableFeePercentage
        id
        slug
        metaPixelId
        publicName
        logo
        preferredLanguage
        description
        facebookLink
        webLink
        email
        type
      }
      translation {
        id
        translationsJSON
      }
      eventUtils {
        id
        inviteFormStyles
      }
    }
  }
`

export const ACCREDITATION_COUNT = gql`
  query AccreditationsCount($eventId: ID!) {
    getEvent(id: $eventId) {
      accreditationsCount
    }
  }
`
export const ATTENDEE_FIELDS = gql`
  query AttendeeFields($eventId: ID!) {
    getEvent(id: $eventId) {
      attendeeFields
    }
  }
`

export const ATTENDEE_FIELDS_WITH_EXTRA_MODULES = gql`
  query AttendeeFieldsWithExtraModules($eventId: ID!) {
    getEvent(id: $eventId) {
      attendeeFields
      extraModules {
        ticketing
      }
    }
  }
`

export const SAVE_ATTENDEE_FIELDS = gql`
  mutation SaveAttendeeFields($eventId: ID!, $attendeeFields: JSON!) {
    saveAttendeeFields(attendeeFields: $attendeeFields, eventId: $eventId) {
      id
    }
  }
`

export const TOGGLE_EVENT_APPLICATIONS = gql`
  mutation toggleEventApplications($eventId: ID!, $applicationsOpen: Boolean!) {
    toggleEventApplications(eventId: $eventId, applicationsOpen: $applicationsOpen) {
      id
    }
  }
`

export const GET_EVENT_CONFERENCE_DATA = gql`
  query getEventConferenceData($eventId: ID!) {
    getEventConferenceData(eventId: $eventId) {
      id
      welcomeTitle
      welcomeSubtitle
      welcomeBackground
      interests
      primaryColor
      venueMap
      googlePlacesKey
    }
  }
`

export const UPDATE_EVENT_CONFERENCE_DATA = gql`
  mutation updateEventConferenceData($eventId: ID!, $input: UpdateEventConferenceDataInput!) {
    updateOrCreateEventConferenceData(eventId: $eventId, input: $input) {
      id
    }
  }
`
export const GET_TICKET_SELLERS_EVENTS = gql`
  query getTicketSellersEvents {
    getTicketSellersEvents {
      id
      applicationsOpen
      soldOut
      canceled
      title
      to
      from
      slug
      cover
      description
      audienceCapacity
      numOfRemainingTickets
      orderItems {
        id
        name
        type
        price
        currency
        createdAt
        itemMeta
        updatedAt
        deletedAt
        quantity
        sectionSeats
        initialQuantity
        from
        to
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
      extraModules {
        ticketing
        floorPlan
        ticketPersonalization
      }
      organization {
        id
        type
      }
    }
  }
`

export const GET_TICKET_SELLERS_EVENT = gql`
  query getTicketSellersEvent($eventId: ID!) {
    getTicketSellersEvent(eventId: $eventId) {
      id
      applicationsOpen
      soldOut
      canceled
      title
      to
      from
      venueId
      slug
      fixedFeePerTicket
      variableFeePercentage
      cover
      description
      audienceCapacity
      numOfRemainingTickets
      extraModules {
        ticketPersonalization
      }
      orderItems {
        id
        name
        type
        price
        currency
        createdAt
        updatedAt
        deletedAt
        quantity
        initialQuantity
        from
        to
      }
      location {
        id
        address1
        address2
        city
        postalCode
        state
        country
        venue
        latitude
        longitude
      }
      organization {
        id
        type
        fixedFeePerTicket
        variableFeePercentage
      }
      eventTemplate {
        id
      }
    }
    getTicketSellerOrganization {
      id
      name
      fees {
        useEventFeePerTicket
        ticketAdditionalFeeAmount
        coreEventAdditionalFeePercentage
      }
    }
  }
`

export const GET_FLOOR_PLAN_AVAILABILITY_OVERVIEW_DATA = gql`
  query GetFloorPlanAvailabilityOverviewData($eventId: ID!) {
    getFloorPlanAvailabilityOverviewData(eventId: $eventId) {
      venue {
        id
        name
        predefinedSections
        seats
        imageUrl
      }
      soldOrderItems {
        id
        name
        itemMeta {
          parter
          table
          min
          max
          imageUrl
          accessCode
        }
        seats
        color
        ticketsNumber
        price
        type
        seatHolders {
          ticketLocation
          name
          email
          subscriptionPlanName
        }
      }
      reservedOrderItems {
        id
        name
        seats
        color
        ticketsNumber
        price
        seatHolders {
          ticketLocation
          name
          email
          subscriptionPlanName
        }
      }
      availableSeats
      disabledSeats
      soldsSeats
      audienceCapacity
    }
  }
`

export const CREATE_ANNUAL_TICKETS_FOR_EVENT = gql`
  mutation CreateAnnualTicketsForEvent($eventId: ID!) {
    createAnnualTicketsForEvent(eventId: $eventId)
  }
`

export const SET_MAX_TICKETS_NUMBER = gql`
  mutation SetMaxTicketsNumber($eventId: ID!, $maxTickets: Int) {
    setMaxTicketsNumber(eventId: $eventId, maxTickets: $maxTickets)
  }
`

export const SET_ATTENDEE_LIMIT = gql`
  mutation SetAttendeeLimit($eventId: ID!, $attendeeLimit: Int) {
    setAttendeeLimit(eventId: $eventId, attendeeLimit: $attendeeLimit)
  }
`

export const SET_EVENT_PASSWORDS_FLAG = gql`
  mutation SetEventPasswordsFlag($eventId: ID!, $eventPasswordsFlag: Boolean!) {
    setEventPasswordsFlag(eventId: $eventId, eventPasswordsFlag: $eventPasswordsFlag) {
      id
      slug
    }
  }
`

export const GET_EVENT_EXTRA_MODULES = gql`
  query GetEventExtraModules($id: ID!) {
    getEvent(id: $id) {
      VATPercentage
      organization {
        id
        VATObligor
      }
      extraModules {
        categoriesAndZones
        mobileApp
        conferenceMobileApp
        expoMobileApp
        ticketing
        floorPlan
        ticketPersonalization
        workshops
      }
    }
    eventHasPendingOrAllowedAttendees(eventId: $id)
  }
`

export const UPDATE_EVENT_EXTRA_MODULES = gql`
  mutation UpdateEventExtraModules(
    $eventId: ID!
    $extraModulesInput: ExtraModulesInput!
    $VATPercentage: Float
  ) {
    updateEventExtraModules(
      eventId: $eventId
      extraModulesInput: $extraModulesInput
      VATPercentage: $VATPercentage
    ) {
      id
      VATPercentage
      extraModules {
        id
      }
    }
  }
`

export const UPDATE_EVENT_COVER = gql`
  mutation UpdateEventCover($eventId: ID!, $cover: String) {
    updateEventCover(eventId: $eventId, cover: $cover)
  }
`

export const UPDATE_EVENT_SCHEDULED_PUBLISH_DATE = gql`
  mutation UpdateEventCover($eventId: ID!, $date: String) {
    updateEventScheduledPublishDate(eventId: $eventId, date: $date) {
      scheduledPublishDate
    }
  }
`

export const GET_EVENT_DYNAMIC_WEBSHOP_TICKET_DATA = gql`
  query getEventDynamicWebshopTicketData($id: ID!) {
    getEvent(id: $id) {
      id
      cover
      organizerMessage
      metadata
    }
  }
`

export const UPDATE_EVENT_DYNAMIC_WEBSHOP_TICKET_DATA = gql`
  mutation UpdateEventDynamicWebshopTicketData(
    $eventId: ID!
    $mainImage: String
    $organizerMessage: String
    $additionalVisual: String
  ) {
    updateEventDynamicWebshopTicketData(
      eventId: $eventId
      mainImage: $mainImage
      organizerMessage: $organizerMessage
      additionalVisual: $additionalVisual
    )
  }
`

// Presentation is fetched separately and reused only against this fresh revision.
export const GET_EVENT_REGISTER_STATE = gql`
  query getEventRegisterState($slug: String!) {
    getEventRegisterState(slug: $slug) {
      serverNow nextSaleTransitionAt displayRevision hasActiveTicketSales
      event {
        id slug numberOfZones to from performanceType managed audienceCapacity venueId eventTemplateId
        soldOut applicationsOpen canceled cancellationNotification organizationId
        fixedFeePerTicket variableFeePercentage attendeeFields flags
        extraModules { workshops mobileApp ticketing floorPlan ticketPersonalization }
        eventPasswords { startsAt expiresAt }
        organization { id type fixedFeePerTicket variableFeePercentage }
      }
    }
  }
`
export const GET_EVENT_REGISTER_DISPLAY = gql`
  query getEventRegisterDisplay($slug: String!, $expectedRevision: String) {
    getEventRegisterDisplay(slug: $slug, expectedRevision: $expectedRevision) {
      id slug title description cover coverImagePrimaryColor { r g b }
      location { id address1 address2 city postalCode state country venue latitude longitude }
      organization { id publicName logo }
      revision generatedAt expiresAt
    }
  }
`

export const GET_EVENT_REGISTER_DISPLAY_LEGACY = gql`
  query getEventRegisterDisplay($slug: String!, $expectedRevision: String) {
    getEventRegisterDisplay(slug: $slug, expectedRevision: $expectedRevision) {
      id slug title description cover coverImagePrimaryColor { r g b }
      location { id address1 address2 city postalCode state country venue latitude longitude }
      revision generatedAt expiresAt
    }
  }
`
